// /src/core/theme.ts
export type Theme = "day" | "night";

const THEME_KEY = "ui_theme";
export const THEME_CHANGED_EVENT = "context:theme-changed";

export function readCurrentTheme(): Theme | null {
  const v = document.documentElement.dataset.theme;
  if (v === "day" || v === "night") return v;
  return null;
}

export function applyTheme(theme: Theme | null | undefined) {
  if (!theme) return;
  const prev = readCurrentTheme();
  document.documentElement.dataset.theme = theme;

  try {
    sessionStorage.setItem(THEME_KEY, theme);
  } catch {
    // ignore
  }

  if (prev !== theme) {
    window.dispatchEvent(new CustomEvent(THEME_CHANGED_EVENT, { detail: { theme } }));
  }
}

export function readBootTheme(): Theme | null {
  try {
    const v = sessionStorage.getItem(THEME_KEY);
    if (v === "day" || v === "night") return v;
    return null;
  } catch {
    return null;
  }
}
